import React from 'react';
import { Drawer, Vehicle } from '../../components';
import { useStyles } from '../../services/material-ui';

const ViewVehicle: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <Vehicle />
      </main>
    </div>
  );
};

export default ViewVehicle;
